import { Typography } from "@cpj-ai/panel-npm-package";
import { Card } from "@heroui/react";

const StatusCard = ({ icon, status, value }: { icon: React.ReactNode; status: string; value: number }) => {
  return (
    <Card className="p-4 w-full gap-2 border border-gray-200 rounded-lg shadow-sm">
      <div className="flex gap-2 items-center ">
        {icon}
        <Typography className="text-medium">{status}</Typography>
      </div>
      <Typography className="text-5xl font-extrabold flex gap-2 items-center">
        {value} <span className="text-tiny text-gray-500 font-light">{` Job Seeker`}</span>
      </Typography>
    </Card>
  );
};

export default StatusCard;
